.screen {
	min-height: 100%;
	padding: var(--space-5);
	max-width: var(--screen-max);
	margin: 0 auto;
	display: grid;
	grid-template-rows: auto 1fr;
	gap: var(--space-6);
}

.back {
	color: var(--ink-muted);
	text-decoration: none;
	font-size: 0.9rem;
	justify-self: start;
}

.back:hover {
	color: var(--ink);
}

.body {
	display: grid;
	place-items: center;
	gap: var(--space-3);
	text-align: center;
}

.emoji {
	font-size: 4rem;
}

.title {
	margin: 0;
	font-size: 2rem;
	font-weight: 600;
}

.hint {
	margin: 0;
	color: var(--ink-muted);
}
